export * from './services';
import {
	AsyncOpService,
	CharacterLimitDirective,
	CommonUtilsService,
	StateHistoryService,
	StopTouchEvent,
	StorageFactory,
	ObjectHandleRepository,
	StaticToggleServiceProvider,
	StorageToggleServiceProvider
} from './services';

export const commonUtilModule = angular
	.module('util.common', [])
	.service('utils', CommonUtilsService)
	.directive('stopTouchEvent', StopTouchEvent)
	.service('objectHandleRepository', ObjectHandleRepository)
	.directive('stopTouchEvent', StopTouchEvent)
	.directive('charLimit', CharacterLimitDirective);

const aysncUtilModule = angular.module('util.async', [ ])
	.service('asyncOpService', AsyncOpService);

const storageFactory = new StorageFactory();
const storageUtilModule = angular	
	.module('util.storage', [])
	.factory('localStorageService', ['$window', ($window:ng.IWindowService) => {
		try {
			return storageFactory.create(getStorageBackend($window, 'localStorage'));
		} catch (e) {
			return StorageFactory.NullStorage;
		}
	}])
	.factory('sessionStorageService', ['$window', ($window:ng.IWindowService)  => {
		try {
			return storageFactory.create(getStorageBackend($window, 'sessionStorage'));
		} catch (e) {
			return StorageFactory.InMemoryStorage;
		}
	}]);

const stateHistoryUtilModule = angular
	.module('util.stateHistory', [
		storageUtilModule.name,
		commonUtilModule.name
	])
	.service('stateHistoryService', StateHistoryService);

const toggleUtilModule = angular
	.module('util.toggle', [
		storageUtilModule.name
	])
	.provider('staticToggleService', StaticToggleServiceProvider)
	.provider('storageToggleService', StorageToggleServiceProvider);

export const UtilModule = angular
	.module('util', [
		storageUtilModule.name,
		commonUtilModule.name,
		stateHistoryUtilModule.name,
		aysncUtilModule.name,
		toggleUtilModule.name
	]);
	
// Attempts to access a storage backend from the window object.
// If the app doesn't have access to the storage backend based on
// browser settings, this function will throw an error.
function getStorageBackend($window, storage: 'localStorage' | 'sessionStorage'): Storage {
	const testKey = 'pxTest';
	let store = $window[storage];
	if(store){
		store.setItem(testKey, testKey);
		store.removeItem(testKey);
	} else {
		throw new Error(`Storage backend ${storage} does not exist.`);
	}

	return store;
}


// WEBPACK FOOTER //
// ./src/util/util.ts